export class LocationInfoHours {
  constructor() {
    this.init();
  }

  init() {
    const wrappers = document.querySelectorAll('.js-locationInfo-wrapper');
    wrappers.forEach((wrapper) => {
      this.initInstance(wrapper);
    });
  }

  initInstance(wrapper) {
    const toggles = wrapper.querySelectorAll('.js-locationInfo-hours-toggle');    
    const allContents = wrapper.querySelectorAll('.js-locationInfo-core-hours');

    if (toggles.length === 0 || allContents.length === 0) return;

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const targetId = toggle.getAttribute('aria-controls');
        const targetContent = document.getElementById(targetId);

        if (!targetContent) return; 

        allContents.forEach((content) => {
          content.classList.add('is-hidden');
        });

        toggles.forEach((btn) => {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-selected', 'false');
        });

        targetContent.classList.remove('is-hidden');
        
        toggle.classList.add('is-selected');
        toggle.setAttribute('aria-selected', 'true');
      });
    });
  }
}